import Reveal from "@/components/site/Reveal";

export function SectionHeading({ eyebrow, title, lead, align = "left", light = false, className = "" }) {
  return (
    <Reveal className={`${align === "center" ? "text-center" : ""} ${className}`}>
      {eyebrow && (
        <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
          <span className="rule" aria-hidden="true" />
          <p className={`eyebrow ${light ? "text-gold" : "text-sage"}`}>{eyebrow}</p>
        </div>
      )}
      {title && (
        <h2
          className={`mt-6 text-4xl sm:text-5xl lg:text-[3.6rem] leading-[1.04] tracking-tight ${
            light ? "text-cream" : "text-wood"
          }`}
        >
          {title}
        </h2>
      )}
      {lead && (
        <p
          className={`mt-7 max-w-2xl text-sm md:text-lg leading-relaxed ${
            align === "center" ? "mx-auto" : ""
          } ${light ? "text-cream/75" : "text-foreground/75"}`}
        >
          {lead}
        </p>
      )}
    </Reveal>
  );
}

export default SectionHeading;
